module.exports = __webpack_public_path__ + "img/20191031163503532.8768935a.jpg";